import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_CUSTOMERS](state, data) {
    state.allCustomers = data
  },
}
